import Option from '@/models/Option';
import React, { memo, useEffect, useState } from 'react';
import './style.scss';

interface Props {
    options: Option[];
    onSelectOption?: (option: Option) => void;
    selectedOptionKey: string;
    disabled?: boolean;
}

const RadioButtonOutline: React.FC<Props> = ({ options, onSelectOption, selectedOptionKey, disabled = false }: Props) => {
    const [selectedOption, setSelectedOption] = useState(selectedOptionKey);

    const handleSelectOption = (option: Option) => {
        if (disabled) {
            return;
        }

        setSelectedOption(option.key);

        if (onSelectOption) {
            onSelectOption(option);
        }
    };

    useEffect(() => {
        if (selectedOptionKey !== selectedOption) {
            setSelectedOption(selectedOptionKey);
        }
    }, [selectedOptionKey]);

    return (
        <div className={`radio-button-outline-container ${disabled ? 'disabled' : ''}`}>
            {options.map((opt) => (
                <span className={selectedOption === opt.key ? 'active' : ''} key={opt.key} onClick={() => handleSelectOption(opt)}>
                    {opt.value}
                </span>
            ))}
        </div>
    );
};

export default memo(RadioButtonOutline);
